import React from "react";
import classNames from "classnames";
import useTranslate from "../../../../modules/local/useTranslate";
import {useToggle} from "react-use";
import {BsCaretDownFill, BsCaretUpFill} from "react-icons/bs";

export const WrapperBlockSider = ({
    icon,
    title,
    children,
    titleColor = 'text-gray-800',
    expanded = false,
    borderColorClass,
    borderTop, borderRight, borderBottom, borderLeft,
}) => {

    const t = useTranslate()
    const [isToggle, toggle] = useToggle()

    // Border accent mặc định khớp màu với titleColor (thay vì luôn dùng 1 màu cố định)
    const accentBorderClass = borderColorClass || titleColor.replace('text-', 'border-')

    return !!children && (
        <div
            style={{
                boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)',
            }}
            className={classNames(
                "p-3 flex flex-col background rounded-xl w-full",
                borderTop && `border-t-2 ${accentBorderClass}`,
                borderRight && `border-r-2 ${accentBorderClass}`,
                borderBottom && `border-b-2 ${accentBorderClass}`,
                borderLeft && `border-l-2 ${accentBorderClass}`,
            )}>
            <h3 className="mb-3 flex items-center gap-2">
                {icon}
                <span
                    className={classNames("flex-1 text-base font-bold uppercase leading-snug tracking-wide", titleColor)}>
                    {t(title)}
                </span>
                {expanded === true && (
                    isToggle ? <BsCaretUpFill onClick={() => toggle()} size={14} className="text-primary"/> :
                        <BsCaretDownFill onClick={() => toggle()} size={14} className={titleColor}/>
                )}
            </h3>
            {expanded === true ? (isToggle && children) : children}
        </div>
    )
}
